'use es6';

/* globals hubspot */
export const openHelpWidget = options => {
  if (hubspot && hubspot.zorse && hubspot.zorse.openHelpWidget) {
    hubspot.zorse.openHelpWidget(options);
  } else {
    console.error('hubspot.zorse is not defined');
  }
};